var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'User Renewal'
      }],
      "title": "All User Renewal"
    }
  }), _c('div', {
    staticClass: "flex-col w-full overflow-visible bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 overflow-visible rounded-lg"
  }, [_c('div', {
    staticClass: "relative w-2/6"
  }, [_c('SearchOutline', {
    attrs: {
      "className": "text-xl absolute top-1/2 left-3 transform -translate-y-1/2"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchTerm,
      expression: "searchTerm"
    }],
    staticClass: "p-2.5 pl-5 w-full text-sm border rounded-md bg-gray-50",
    attrs: {
      "type": "search",
      "placeholder": "Search Email"
    },
    domProps: {
      "value": _vm.searchTerm
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      },
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value;
      }, _vm.onSearch]
    }
  })], 1), _c('div', {
    staticClass: "relative flex justify-end w-3/4 overflow-visible"
  }, [_c('div', {
    ref: "filterContainer",
    staticClass: "relative overflow-visible"
  }, [_c('Button', {
    staticClass: "relative",
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": function ($event) {
        _vm.showFilterModal = !_vm.showFilterModal;
      }
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('FilterFilled', {
          attrs: {
            "className": "h-3 w-3 text-gray-800"
          }
        })];
      },
      proxy: true
    }, {
      key: "iconAfter",
      fn: function () {
        return [_c('ChevronDownFilled', {
          attrs: {
            "className": "h-3 w-3 text-gray-800"
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" Filter "), _vm.activeFilterCount > 0 ? _c('span', {
    staticClass: "absolute flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full -top-2 -right-2"
  }, [_vm._v(" " + _vm._s(_vm.activeFilterCount) + " ")]) : _vm._e()]), _c('RenewalFilterModal', {
    attrs: {
      "visible": _vm.showFilterModal,
      "initial-filters": _vm.appliedFilters
    },
    on: {
      "apply-filter": _vm.handleApplyFilter,
      "reset-filter": _vm.handleResetFilter,
      "update:visible": function ($event) {
        _vm.showFilterModal = false;
      }
    }
  })], 1)])])]), _c('Table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "data": _vm.renewals,
      "rowKey": _vm.tableRowKeys,
      "currentPage": _vm.currentPage,
      "perPage": _vm.perPage,
      "isLoading": _vm.isLoading,
      "withScrollX": true,
      "withAction": false,
      "className": "mb-2"
    },
    on: {
      "sort": _vm.handleTableSort
    },
    scopedSlots: _vm._u([{
      key: "masked_credit_card",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.hideCode(value, 'masked')) + " ")])];
      }
    }, {
      key: "renewal_status",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('div', [_c('Label', {
          attrs: {
            "variant": _vm.getStatusVariant(value)
          }
        }, [_vm._v(" " + _vm._s(_vm.capitalizeFirst(value || 'Unknown')) + " ")])], 1)];
      }
    }, {
      key: "start_date",
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatTime(value)) + " ")])];
      }
    }, {
      key: "expired_date",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatTime(value)) + " ")])];
      }
    }])
  }), Number(_vm.totalRows) ? _c('div', {
    staticClass: "flex justify-between pt-4 pl-3 pr-3 mt-1 mb-2 bg-white border-t border-gray-100"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(Number(_vm.totalRows) >= _vm.perPage ? _vm.perPage : Number(_vm.totalRows)) + " "), _c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "disabled": _vm.isLoading,
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }